import React, { Component } from 'react';
import ColorItem from './ColorItem';

export default class ColorBlock extends Component {

    
    render(){
        return <div style={{paddingBottom: "10px", width: "30px", float: "left", textAlign:'center', marginRight: "10px",background:(this.props.selected ? '#A5E8E2' : 'transparent')}} onClick={this.props.onClick}>
                {this.props.colors.map((c,idx) => {
                    return <ColorItem key={"coloritem-" + idx} color={c}/>
                })}
            </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/color-block/ColorBlock.jsx